import { useEffect, useState } from 'react';
import { MessageCircle, Phone, Mail, X } from 'lucide-react';
import { publicGet } from '../../lib/publicApi';

const cleanPhone = (p) => (p || '').replace(/[^0-9+]/g, '');
const toWhatsApp = (p) => {
  const cleaned = cleanPhone(p);
  // Convert "06..." to "336..." international
  if (cleaned.startsWith('0') && cleaned.length === 10) return `33${cleaned.slice(1)}`;
  if (cleaned.startsWith('+')) return cleaned.slice(1);
  return cleaned;
};

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    publicGet('/api/public/site-config')
      .then(setConfig)
      .catch(() => {});
  }, []);

  if (!config) return null;

  const phones = (config.wero_phones && config.wero_phones.length > 0)
    ? config.wero_phones
    : (config.contact_phone ? [config.contact_phone] : []);
  const primaryPhone = phones[0];
  const email = config.contact_email;

  const waMessage = encodeURIComponent("Bonjour Era Lodge, j'ai une question concernant votre suite.");
  const waUrl = primaryPhone ? `https://wa.me/${toWhatsApp(primaryPhone)}?text=${waMessage}` : null;
  const telUrl = primaryPhone ? `tel:+${toWhatsApp(primaryPhone)}` : null;
  const mailUrl = email ? `mailto:${email}?subject=${encodeURIComponent("Question sur Era Lodge")}` : null;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
      {open && (
        <div className="flex flex-col gap-2.5 animate-fade-in-down">
          {waUrl && (
            <a href={waUrl} target="_blank" rel="noopener noreferrer"
               className="group flex items-center gap-3 px-4 py-3 bg-[#25D366] text-white shadow-xl hover:shadow-2xl hover:scale-[1.02] transition-all font-body text-sm"
               data-testid="floating-whatsapp">
              <MessageCircle className="w-5 h-5" strokeWidth={1.8} />
              <span className="font-medium">WhatsApp · réponse rapide</span>
            </a>
          )}
          {telUrl && (
            <a href={telUrl}
               className="group flex items-center gap-3 px-4 py-3 bg-[#D4AF37] text-[#0D0C0B] shadow-xl hover:shadow-2xl hover:scale-[1.02] transition-all font-body text-sm"
               data-testid="floating-tel">
              <Phone className="w-5 h-5" strokeWidth={1.8} />
              <span className="font-medium">Appeler — {primaryPhone}</span>
            </a>
          )}
          {mailUrl && (
            <a href={mailUrl}
               className="group flex items-center gap-3 px-4 py-3 bg-[#141312] text-[#F5F2EB] border border-[#D4AF37]/40 shadow-xl hover:bg-[#D4AF37]/10 transition-all font-body text-sm"
               data-testid="floating-email">
              <Mail className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.8} />
              <span className="font-medium">Envoyer un email</span>
            </a>
          )}
        </div>
      )}
      <button
        onClick={() => setOpen(o => !o)}
        className="w-14 h-14 bg-[#D4AF37] hover:bg-[#F0C84B] text-[#0D0C0B] rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-105"
        data-testid="floating-contact-toggle"
        aria-label="Contact"
      >
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
      </button>
    </div>
  );
}
